import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { MdVerified } from "react-icons/md";
import { TailSpin } from "react-loader-spinner";
import { Select } from "antd";
import PaymentForms from "./sub-components/PaymentForms";
import Flag from "react-world-flags";
import MapView from "./sub-components/Map";
import { KeyboardArrowDown } from "@mui/icons-material";
import EmailForm from "./sub-components/EmailForm";
import CourseCard from "./sub-components/CourseCard";
import CountryFormSync from "./CountryFormSync";
import { useCountry } from "../context/CountryContext";
import {
  getTimeZones,
  getCountryCodes,
  getStatesByCountry,
  getTaxRate,
  getSubjects,
  registerCandidate,
  getUserLocation,
  CreatePayments,
  createRazorpayOrder,
  verifyRazorpayPayment,
  isCandidateAlreadyExists,
  getApplicationMode,
} from "../services/publicApi";
import "../css/index.css";
import { APP_CONFIG } from "../config/appConfig";
import { FaSearch, FaTimes } from "react-icons/fa";
import {
  getCoursePricing,
  getCoursePayableAmount,
  applyTaxAmount,
} from "../utils/coursePricing";

const { PUBLIC_URL } = process.env;

const getPopupContainer = () => document.body;

const RegistrationStateLoader = ({ teleCode, setStates, setStatesLoading }) => {
  const { values } = useFormikContext();
  const country = values.country || "";

  useEffect(() => {
    let cancelled = false;

    const loadStates = async () => {
      if (!country) {
        setStates([]);
        setStatesLoading(false);
        return;
      }

      const matched = teleCode?.find(
        (item) => item.name?.toLowerCase() === String(country).toLowerCase(),
      );

      setStates([]);
      setStatesLoading(true);
      try {
        const res = await getStatesByCountry({
          country,
          iso2: matched?.iso2 || "",
        });
        if (!cancelled) {
          setStates(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
        if (!cancelled) {
          setStates([]);
        }
      } finally {
        if (!cancelled) {
          setStatesLoading(false);
        }
      }
    };

    loadStates();

    return () => {
      cancelled = true;
    };
  }, [country, teleCode, setStates, setStatesLoading]);

  return null;
};

const RegistrationTaxLoader = ({ teleCode, setTaxRate }) => {
  const { values } = useFormikContext();
  const country = values.country || "";
  const state = values.state || "";

  useEffect(() => {
    let cancelled = false;

    const loadTaxRate = async () => {
      if (!country) {
        setTaxRate(0);
        return;
      }

      const matched = teleCode?.find(
        (item) => item.name?.toLowerCase() === String(country).toLowerCase(),
      );

      try {
        const res = await getTaxRate({
          country,
          state,
          iso2: matched?.iso2 || "",
        });
        if (!cancelled) {
          setTaxRate(Number(res.data?.data?.rate) || 0);
        }
      } catch (error) {
        console.error("Error fetching tax rate:", error);
        if (!cancelled) {
          setTaxRate(0);
        }
      }
    };

    loadTaxRate();

    return () => {
      cancelled = true;
    };
  }, [country, state, teleCode, setTaxRate]);

  return null;
};

const Home = () => {
  const WebURL = APP_CONFIG.ASSET_BASE;
  const dashboard_Video = APP_CONFIG.DASHBOARD_VIDEO;
  const nextestify_Video = APP_CONFIG.NEXTESTIFY_VIDEO;
  const [searchTerm, setSearchTerm] = useState("");
  const {
    selectedCountry,
    setSelectedCountry,
    teleCode: contextTeleCode,
    setTeleCode: setContextTeleCode,
  } = useCountry();
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [successHeading, setSuccessHeading] = useState("Register Successfully");

  const validationSchema = Yup.object({
    firstname: Yup.string().required("First Name is required"),
    lastname: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    telecode: Yup.string().required("Telecode is required"),
    phone: Yup.string()
      .matches(
        // /^[0-9]{10,15}$/,
        /^\d{10}$/,
        // "Phone number must be between 10 and 15 digits"
        "Phone number must be 10 digits",
      )
      .required("Phone number is required"),
    gender: Yup.string().required("Choose your Gender"),
    timezone: Yup.string().required("Choose your Timezone"),
    country: Yup.string().required("Country is required"),
    state: Yup.string()
      .trim()
      .required("State is required")
      .max(100, "State must be 100 characters or less"),
  });

  const [timeZone, setTimezone] = useState([]);
  const [teleCode, setTeleCode] = useState([]);
  const [states, setStates] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [taxRate, setTaxRate] = useState(0);
  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const [sub, setSub] = useState([]);
  const [errorMsgCourse, setErrorMsgCourse] = useState(false);
  const [showErrorMsgUser, setShowErrorMsgUser] = useState(false);
  const [errorMsgUser, setErrorMsgUser] = useState("");
  const [userSaved, setUserSaved] = useState(false);
  const [initialTeleCode, setInitialTeleCode] = useState("");
  const [initialTimeZone, setInitialTimeZone] = useState("");
  const [initialCountry, setInitialCountry] = useState(() => {
    return sessionStorage.getItem("selectedCountry") || "";
  });
  const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    gender: "",
    timezone: initialTimeZone,
    telecode: initialTeleCode,
    country: initialCountry,
    state: "",
  };
  const [submitted, setSubmitted] = useState(false);
  const [totalAmt, setTotalAmt] = useState(0);
  const [discountAmt, setdiscountAmt] = useState(0);
  const [formVisible, setFormVisible] = useState(true);
  const [redeemVisible, setRedeemVisible] = useState(false);
  const [showPaymentPendingModal, setShowPaymentPendingModal] = useState(false);
  const [existingCandidateId, setExistingCandidateId] = useState(null);
  const [cuserid, setcuserid] = useState(0);
  const isExpanded = false;
  const [toolTip, setToolTip] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const charLimit = 80;
  const [payThroughVisible, setPayThroughVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRedeeming, setIsRedeeming] = useState(false);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 250);
    }
  }, [location]);

  useEffect(() => {
    const scriptFiles = [
      `${process.env.PUBLIC_URL}/vendor/jquery/jquery.min.js`,
      `${process.env.PUBLIC_URL}/assets/js/isotope.min.js`,
      `${process.env.PUBLIC_URL}/assets/js/owl-carousel.js`,
      `${process.env.PUBLIC_URL}/assets/js/lightbox.js`,
      `${process.env.PUBLIC_URL}/assets/js/tabs.js`,
      `${process.env.PUBLIC_URL}/assets/js/video.js`,
      `${process.env.PUBLIC_URL}/assets/js/slick-slider.js`,
      `${process.env.PUBLIC_URL}/assets/js/custom.js`,
      `${process.env.PUBLIC_URL}/vendor/bootstrap/js/bootstrap.min.js`,
    ];

    const loadScriptsSequentially = (scripts) => {
      if (scripts.length === 0) return;

      const [currentScript, ...remainingScripts] = scripts;

      const script = document.createElement("script");
      script.src = currentScript;
      script.async = true;

      document.body.appendChild(script);

      script.onload = () => {
        if (
          currentScript.includes("isotope.min.js") &&
          typeof window.Isotope !== "undefined"
        ) {
          const gridElement = document.querySelector(".grid");
          if (gridElement) {
            const isotopeInstance = new window.Isotope(gridElement, {
              itemSelector: ".grid-item",
              layoutMode: "fitRows",
            });
            console.log(isotopeInstance);
          }
        }

        loadScriptsSequentially(remainingScripts);
      };

      script.onerror = () => {
        console.error(`Failed to load script: ${currentScript}`);
      };
    };

    loadScriptsSequentially(scriptFiles);

    const interval = setInterval(() => {
      if (window.$) {
        clearInterval(interval);
      }
    }, 100);

    return () => {
      scriptFiles.forEach((src) => {
        const scriptToRemove = document.querySelector(`script[src="${src}"]`);
        if (scriptToRemove) {
          document.body.removeChild(scriptToRemove);
        }
      });
    };
  }, [WebURL]);

  useEffect(() => {
    if (contextTeleCode?.length && !teleCode.length) {
      setTeleCode(contextTeleCode);
    }
  }, [contextTeleCode, teleCode.length]);

  useEffect(() => {
    let cancelled = false;
    let logoIntervalId;

    const formatLogoPath = (logoItem) =>
      typeof logoItem === "string"
        ? logoItem.replace(/\\/g, "/").replace(/^[A-Za-z]:/, WebURL)
        : logoItem;

    const mapSubjectsWithLogo = (categories = []) =>
      categories.map((item) => {
        const updatedLogo = Array.isArray(item.logo)
          ? item.logo.map(formatLogoPath)
          : item.logo;
        const logoOptions = Array.isArray(updatedLogo) ? updatedLogo : [];
        const randomLogo =
          logoOptions.length > 0
            ? logoOptions[Math.floor(Math.random() * logoOptions.length)]
            : updatedLogo;

        return { ...item, logo: randomLogo };
      });

    // Subject cards must render as soon as getSubjects resolves — do not wait
    // for timezones/country codes/location (those can be slower or hang).
    const fetchSubjects = async () => {
      try {
        const resCourse = await getSubjects();
        if (cancelled) return;

        if (resCourse.status === 200 || resCourse.status === 304) {
          const initialModifiedData = mapSubjectsWithLogo(
            resCourse.data?.categories,
          );
          console.log("initial :", initialModifiedData);
          setCourses(initialModifiedData || []);

          if (!cancelled) {
            logoIntervalId = setInterval(() => {
              if (cancelled) return;
              setCourses(mapSubjectsWithLogo(resCourse.data?.categories));
            }, 30000);
          }
        }
      } catch (error) {
        console.error("Error fetching subjects:", error);
      } finally {
        if (!cancelled) {
          setCoursesLoading(false);
        }
      }
    };

    const fetchMasterData = async () => {
      try {
        const [tzResult, teleResult] = await Promise.allSettled([
          getTimeZones(),
          getCountryCodes(),
        ]);

        if (cancelled) return;

        const resTimeZone =
          tzResult.status === "fulfilled" ? tzResult.value : null;
        const resTeleCode =
          teleResult.status === "fulfilled" ? teleResult.value : null;

        if (tzResult.status === "rejected") {
          console.error("Error fetching timezones:", tzResult.reason);
        }
        if (teleResult.status === "rejected") {
          console.error("Error fetching country codes:", teleResult.reason);
        }

        let timeZoneList = [];
        if (
          resTimeZone &&
          (resTimeZone.status === 200 || resTimeZone.status === 304)
        ) {
          timeZoneList = resTimeZone.data.data;
          setTimezone(timeZoneList);
        }

        let countryCodes = [];
        if (
          resTeleCode &&
          (resTeleCode.status === 200 || resTeleCode.status === 304)
        ) {
          countryCodes = resTeleCode.data.data;
          setTeleCode(countryCodes);
          setContextTeleCode(countryCodes);
        }

        const savedCountry = sessionStorage.getItem("selectedCountry");
        const storedData = sessionStorage.getItem("locationData");

        const applyDetectedCountry = (matchedCountry) => {
          const countryToUse = savedCountry || matchedCountry?.name || "";
          if (countryToUse) {
            setInitialCountry(countryToUse);
            if (!savedCountry) {
              setSelectedCountry(countryToUse);
            }
            const countryForTele =
              countryCodes.find(
                (item) =>
                  item.name?.toLowerCase() === countryToUse.toLowerCase(),
              ) || matchedCountry;
            if (countryForTele?.iso2 && countryForTele?.dialCode != null) {
              setInitialTeleCode(
                `${countryForTele.iso2}-${countryForTele.dialCode}`,
              );
            }
          }
        };

        const resolveTimeZone = (matchedTimeZone, ipTimezone) => {
          if (matchedTimeZone && typeof matchedTimeZone === "string") {
            // Prefer a value that exists in the timezone master list
            if (
              !timeZoneList.length ||
              timeZoneList.some(
                (tz) => tz.toLowerCase() === matchedTimeZone.toLowerCase(),
              )
            ) {
              return matchedTimeZone;
            }
          }
          if (ipTimezone && timeZoneList.length) {
            return timeZoneList.find((item) =>
              item.toLowerCase().startsWith(String(ipTimezone).toLowerCase()),
            );
          }
          return matchedTimeZone || null;
        };

        if (storedData) {
          const { matchedCountry, matchedTimeZone, ipTimezone } =
            JSON.parse(storedData);
          console.log("not fetching");
          const resolvedTZ = resolveTimeZone(matchedTimeZone, ipTimezone);
          if (resolvedTZ) {
            setInitialTimeZone(resolvedTZ);
          }

          applyDetectedCountry(matchedCountry);
        } else {
          try {
            const { data } = await getUserLocation();
            if (cancelled) return;

            const userISO2 = data.country;
            const userTZ = data.timezone;
            const initialCodeCountry = countryCodes || [];
            console.log("fetching");

            const matchedCountry = userISO2
              ? initialCodeCountry.find((item) =>
                  item.iso2
                    ?.toLowerCase()
                    .startsWith(String(userISO2).toLowerCase()),
                )
              : null;
            const matchedTimeZone = userTZ
              ? timeZoneList.find((item) =>
                  item.toLowerCase().startsWith(String(userTZ).toLowerCase()),
                )
              : null;

            if (matchedTimeZone) {
              setInitialTimeZone(matchedTimeZone);
            }

            applyDetectedCountry(matchedCountry);

            const dataToStore = {
              matchedCountry,
              matchedTimeZone,
              ipTimezone: userTZ || null,
            };

            sessionStorage.setItem("locationData", JSON.stringify(dataToStore));
          } catch (locationError) {
            console.error("Error detecting location from IP:", locationError);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSubjects();
    fetchMasterData();

    return () => {
      cancelled = true;
      if (logoIntervalId) {
        clearInterval(logoIntervalId);
      }
    };
  }, [WebURL, setSelectedCountry, setContextTeleCode]);

  const handleCoursesChange = (value) => {
    const qcID = value.qcId;
    const pricing = getCoursePricing(value, selectedCountry);
    const amt = applyTaxAmount(
      getCoursePayableAmount(value, selectedCountry),
      taxRate,
    );
    const discountedAmt = pricing.isDiscounted ? pricing.discountedAmount : 0;

    console.log("Country:", selectedCountry);
    console.log("Calculated Amt:", amt);

    setSub((prevState) => {
      if (submitted) return prevState;

      if (prevState.includes(qcID)) {
        const newState = prevState.filter((id) => id !== qcID);
        setTotalAmt((prevTotal) => prevTotal - amt);
        setdiscountAmt((prevDiscount) => prevDiscount - discountedAmt);
        return newState;
      } else {
        const newState = [...prevState, qcID];
        setTotalAmt((prevTotal) => prevTotal + amt);
        setdiscountAmt((prevDiscount) => prevDiscount + discountedAmt);

        return newState;
      }
    });
  };

  useEffect(() => {
    if (submitted || sub.length === 0 || !courses.length) return;

    let total = 0;
    let discount = 0;

    sub.forEach((qcId) => {
      const course = courses.find((item) => item.qcId === qcId);
      if (!course) return;

      const pricing = getCoursePricing(course, selectedCountry);
      total += getCoursePayableAmount(course, selectedCountry);
      discount += pricing.isDiscounted ? pricing.discountedAmount : 0;
    });

    setTotalAmt(applyTaxAmount(total, taxRate));
    setdiscountAmt(discount);
  }, [selectedCountry, taxRate]);

  // Handle search with query params
  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    try {
      const params = value ? { search: value } : {};
      const resCourse = await getSubjects(params);
      if (resCourse.status === 200 || resCourse.status === 304) {
        const formatLogoPath = (logoItem) =>
          typeof logoItem === "string"
            ? logoItem.replace(/\\/g, "/").replace(/^[A-Za-z]:/, WebURL)
            : logoItem;
        const modifiedData = resCourse.data?.categories?.map((item) => {
          const updatedLogo = Array.isArray(item.logo)
            ? item.logo.map(formatLogoPath)
            : item.logo;
          const randomLogo =
            updatedLogo[Math.floor(Math.random() * updatedLogo.length)];
          return { ...item, logo: randomLogo };
        });
        setCourses(modifiedData);
      }
    } catch (error) {
      console.error("Error searching courses:", error);
    }
  };

  // Clear search
  const clearSearch = async () => {
    setSearchTerm("");

    try {
      const resCourse = await getSubjects({});
      if (resCourse.status === 200 || resCourse.status === 304) {
        const formatLogoPath = (logoItem) =>
          typeof logoItem === "string"
            ? logoItem.replace(/\\/g, "/").replace(/^[A-Za-z]:/, WebURL)
            : logoItem;
        const modifiedData = resCourse.data?.categories?.map((item) => {
          const updatedLogo = Array.isArray(item.logo)
            ? item.logo.map(formatLogoPath)
            : item.logo;
          const randomLogo =
            updatedLogo[Math.floor(Math.random() * updatedLogo.length)];
          return { ...item, logo: randomLogo };
        });
        setCourses(modifiedData);
      }
    } catch (error) {
      console.error("Error clearing search:", error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("cuserid", cuserid);
  }, [cuserid]);

  const isTestModeResponse = (data) =>
    data?.mode === "TEST" || data?.testMode === true || data?.skipPayment === true || data?.skipGateway === true;

  const showRegistrationSuccess = () => {
    setUserSaved(false);
    setRedeemVisible(false);
    setPayThroughVisible(false);
    setShowPaymentPendingModal(false);
    setFormVisible(false);
    setSuccessHeading("Register Successfully");
    setPaymentSuccess(true);
  };

  const completeTestModePayment = async (candidateId) => {
    const payload = {
      amountInINR: Math.round(totalAmt) || 0,
      cid: sub,
      cuserid: candidateId,
    };
    await CreatePayments(payload);
    showRegistrationSuccess();
    return true;
  };

  const fetchIsTestMode = async () => {
    try {
      const modeRes = await getApplicationMode();
      return isTestModeResponse(modeRes?.data);
    } catch {
      return false;
    }
  };

  const handleSubmit = async (value, actions) => {
    try {
      if (sub.length > 0) {
        setIsSubmitting(true);
        // 🔥 STEP 1: Check existing user
        const checkRes = await isCandidateAlreadyExists({
          email: value.email,
          phoneNumber: `${value.telecode}-${value.phone}`,
        });

        if (checkRes.data.flag === "Y") {
          setSelectedCountry(value.country);

          sessionStorage.setItem(
            "pendingPaymentData",
            JSON.stringify({
              country: value.country,
              candidateId: checkRes.data.candidateId,
            }),
          );

          const pendingCandidateId = checkRes.data.candidateId;
          setExistingCandidateId(pendingCandidateId);
          setcuserid(pendingCandidateId);

          if (await fetchIsTestMode()) {
            try {
              await completeTestModePayment(pendingCandidateId);
              actions.resetForm();
            } catch (error) {
              console.error("Test mode payment failed:", error);
              setShowErrorMsgUser(true);
              setErrorMsgUser("Unable to complete registration. Please try again.");
            } finally {
              setIsSubmitting(false);
            }
            return;
          }

          setShowPaymentPendingModal(true);
          setIsSubmitting(false);
          return;
        }
        const formDataWithCourses = {
          ...value,
          subject: sub,
        };

        const formDataToSend = new FormData();
        formDataToSend.append("firstname", value.firstname);
        formDataToSend.append("lastname", value.lastname);
        formDataToSend.append("email", value.email);
        formDataToSend.append("phone", `${value.telecode}-${value.phone}`);
        formDataToSend.append("gender", value.gender);
        formDataToSend.append("timezone", value.timezone);
        formDataToSend.append("country", value.country);
        formDataToSend.append("state", (value.state || "").trim());
        formDataWithCourses.subject.forEach((item) =>
          formDataToSend.append("subject[]", item),
        );

        try {
          const res = await registerCandidate(formDataToSend);
          const codeValue = await getCountryCodes();

          if (res) {
            setSelectedCountry(value.country);
            setIsSubmitting(false);
            setcuserid(res.data.cuserid);
            setShowErrorMsgUser(false);
            setErrorMsgUser("");
            setUserSaved(true);
            setSubmitted(true);

            setTeleCode([]);

            setTimeout(() => {
              setTeleCode(codeValue.data.data);
              setContextTeleCode(codeValue.data.data);
            }, 1000);

            setFormVisible(false);

            if (isTestModeResponse(res.data) || (await fetchIsTestMode())) {
              try {
                if (!isTestModeResponse(res.data)) {
                  await completeTestModePayment(res.data.cuserid);
                } else {
                  showRegistrationSuccess();
                }
              } catch (error) {
                console.error("Test mode payment failed:", error);
                setShowErrorMsgUser(true);
                setErrorMsgUser("Unable to complete registration. Please try again.");
                setFormVisible(true);
                setUserSaved(false);
              }
              actions.resetForm();
              return;
            }

            setTimeout(() => {
              setUserSaved(false);
              setRedeemVisible(true);
            }, 1000);

            actions.resetForm();
          }
        } catch (error) {
          console.error("error :", error);

          setIsSubmitting(false);
          if (error.status === 409) {
            setShowErrorMsgUser(true);
            setErrorMsgUser(error.response.data.message);
            setUserSaved(false);
          }
        }

        setErrorMsgCourse(false);
      } else {
        setErrorMsgCourse(true);
        setUserSaved(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
    }
  };

  const handleNumberKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (charCode < 48 || charCode > 57 || inputValue.length >= 10) {
      event.preventDefault();
    }
  };

  const handleLetterKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (
      !(
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode === 32
      ) ||
      inputValue.length >= 50
    ) {
      event.preventDefault();
    }
  };

  const handleToolTip = (qcId) => {
    if (toolTip === qcId) {
      setToolTip(null);
    } else {
      setToolTip(qcId);
    }
  };

  useEffect(() => {
    if (toolTip !== null) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [toolTip]);

  const loadRazorpayScript = () =>
    new Promise((resolve, reject) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () =>
        reject(new Error("Unable to load Razorpay Checkout"));
      document.body.appendChild(script);
    });

  const openRazorpay = async (candidateId) => {
    const userId = candidateId || cuserid;
    try {
      setShowErrorMsgUser(false);
      setErrorMsgUser("");

      if (await fetchIsTestMode()) {
        await completeTestModePayment(userId);
        return;
      }

      const payableAmount = Math.round(totalAmt);
      const orderRes = await createRazorpayOrder({
        amountInINR: payableAmount,
        cid: sub,
        cuserid: userId,
      });
      console.log("[Razorpay] createRazorpayOrder response", {
        success: orderRes?.data?.success || false,
        orderId: orderRes?.data?.orderId || null,
        amount: orderRes?.data?.amount || null,
        alreadyPaid: orderRes?.data?.alreadyPaid || false,
        reused: orderRes?.data?.reused || false,
      });

      if (isTestModeResponse(orderRes?.data)) {
        await completeTestModePayment(userId);
        return;
      }

      if (orderRes?.data?.alreadyPaid) {
        showRegistrationSuccess();
        return;
      }

      const razorpayKey = orderRes?.data?.keyId;
      const orderId = orderRes?.data?.orderId;

      if (!razorpayKey || !orderId) {
        throw new Error("Razorpay payment details not found");
      }

      await loadRazorpayScript();

      const options = {
        key: razorpayKey,
        amount: orderRes.data.amount,
        currency: orderRes.data.currency || "INR",
        name: "Nextestify",
        description: "Pay to start your 1-week free trial.",
        order_id: orderId,
        handler: async function (response) {
          await handlePaymentSuccess(response, userId);
        },
        theme: {
          color: "#3399cc",
        },
      };

      if (orderRes?.data?.prefill) {
        options.prefill = orderRes.data.prefill;
      }

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        console.error("[Razorpay] Checkout payment.failed", {
          code: response?.error?.code || null,
          reason: response?.error?.reason || null,
          description: response?.error?.description || null,
        });
        setShowErrorMsgUser(true);
        setErrorMsgUser(
          response?.error?.description ||
            "Razorpay payment failed. Please try again to continue your free trial.",
        );
      });

      rzp.open();
    } catch (err) {
      console.error("Razorpay payment failed:", err);
      setShowErrorMsgUser(true);
      setErrorMsgUser(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "Unable to start Razorpay payment. Please try again.",
      );
    }
  };

  const handlePaymentSuccess = async (response, candidateId) => {
    try {
      const payload = {
        amountInINR: Math.round(totalAmt),
        cid: sub,
        cuserid: candidateId || cuserid,
        razorpay_payment_id: response?.razorpay_payment_id,
        razorpay_order_id: response?.razorpay_order_id,
        razorpay_signature: response?.razorpay_signature,
      };

      const paymentRes = await verifyRazorpayPayment(payload);
      console.log("[Razorpay] verifyRazorpayPayment response", {
        success: paymentRes?.data?.success || false,
        paymentStatus: paymentRes?.data?.paymentStatus || null,
        orderId: paymentRes?.data?.orderId || null,
        alreadyPaid: Boolean(paymentRes?.data?.alreadyPaid),
      });

      if (isTestModeResponse(paymentRes?.data)) {
        showRegistrationSuccess();
        return true;
      }
      if (!paymentRes?.data?.success) {
        setShowErrorMsgUser(true);
        setErrorMsgUser(
          paymentRes?.data?.message ||
            "Razorpay payment could not be verified.",
        );
        return false;
      }
      showRegistrationSuccess();
      return true;
    } catch (error) {
      console.error("Error after Razorpay payment:", error);
      setShowErrorMsgUser(true);
      setErrorMsgUser(
        error?.response?.data?.message ||
          "Razorpay payment could not be verified. Please try again.",
      );
      return false;
    }
  };

  const handlePayThrough = async (event) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    setIsRedeeming(true);

    try {
      if (await fetchIsTestMode()) {
        await completeTestModePayment(cuserid);
        return;
      }

      const country = selectedCountry?.toLowerCase().trim();

      if (country?.includes("india")) {
        await openRazorpay(cuserid);
      } else {
        setRedeemVisible(false);
        setPayThroughVisible(true);
      }
    } catch (error) {
      console.error("Error starting payment:", error);
      setShowErrorMsgUser(true);
      setErrorMsgUser("Unable to start payment. Please try again.");
    } finally {
      setIsRedeeming(false);
    }
  };

  const handleNoTQ = () => {
    setFormVisible(true);
    setRedeemVisible(false);
    setSubmitted(false);
    setSub([]);
  };

  const finalrender = () => {
    setTotalAmt(0);
    setdiscountAmt(0);
    setFormVisible(true);
    setRedeemVisible(false);
    setPayThroughVisible(false);
    setSubmitted(false);
    setSub([]);
  };

  useEffect(() => {
    const pendingData = sessionStorage.getItem("pendingPaymentData");

    if (pendingData) {
      const parsed = JSON.parse(pendingData);

      if (parsed?.country) {
        setSelectedCountry(parsed.country);
      }

      if (parsed?.candidateId) {
        setExistingCandidateId(parsed.candidateId);
      }
    }
  }, []);

  return (
    <div>
      <section className="relative h-screen w-full">
        {/* VIDEO */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute w-full h-full object-cover"
        >
          <source src={dashboard_Video} type="video/mp4" />
        </video>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-[#0b1d3a]/70"></div>

        {/* HERO CONTENT */}
        <div className="relative z-10 flex flex-col items-center xl:pb-14 justify-center h-full text-center px-4 2xl:pb-32">
          <div>
            <h1 className="text-white text-3xl md:text-5xl font-bold uppercase max-w-4xl">
              Turn your <span className="text-yellow-500">tests</span> into
              success stories
            </h1>

            <h6 className="text-white text-sm md:text-base mt-6 font-semibold uppercase">
              AI-powered skills and knowledge assessment software,
              <br /> serving for more educational users worldwide.
            </h6>

            <button className="mt-6 bg-[#F4A62A] text-white px-6 py-3 rounded-md font-semibold hover:bg-[#F4A62A]/80 transition">
              <a href="#section3">Sign up</a>
            </button>
          </div>
        </div>

        {/* ✅ FEATURES */}
        <div className="absolute bottom-24 left-0 w-full z-40">
          <div className="max-w-6xl 2xl:max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-6 2xl:gap-10">
            {[
              {
                title: "Tests",
                icon: "fa-pencil",
                desc: "Make online tests to get genuine insights into skills and knowledge. Avoid mis-hires and pointless interviews. See the training impact.",
              },
              {
                title: "Quizzes",
                icon: "fa-graduation-cap",
                desc: "Make quizzes with AI assistance. Evaluate skills and knowledge for deeper understanding through comprehensive analytics.",
              },
              {
                title: "Study Material",
                icon: "fa-book",
                desc: "Study materials in exam portals provide organized resources aligned with the syllabus, helping candidates prepare effectively. They include topic-wise content, practice questions, and reference materials to enhance learning.",
              },
            ].map((item, i) => (
              <div key={i} className="group relative h-[100px]">
                {/* CARD */}
                <div
                  className="
              absolute bottom-0 left-0 w-full
              bg-[#0f172a] text-white
              p-6 h-[70px]
              group-hover:h-[200px] 2xl:group-hover:h-[230px]
              transition-all duration-500 ease-in-out
              overflow-hidden shadow-xl
            "
                >
                  {/* YELLOW BACKGROUND */}
                  <div
                    className="
                absolute inset-0 bg-[#F4A62A]
                opacity-0 group-hover:opacity-100
                transition-all duration-500
                z-0
              "
                  ></div>

                  {/* CONTENT */}
                  <div className="relative z-10">
                    {/* TITLE */}
                    <div className="flex items-center gap-3">
                      <i className={`fa ${item.icon}`}></i>
                      <h4 className="text-lg font-semibold uppercase">
                        {item.title}
                      </h4>
                    </div>

                    {/* DESCRIPTION */}
                    <div
                      className="
                  opacity-0 group-hover:opacity-100
                  mt-2 text-sm 2xl:text-base  font-medium
                  transition-all duration-500
                "
                    >
                      {item.desc}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section why-us" id="section2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-heading">
                <h2>Why choose NexTestify?</h2>
              </div>
            </div>
            <div className="col-md-12 ">
              <div id="tabs">
                <ul className="tabs-nav">
                  <li
                    onClick={() => setActiveTab(1)}
                    className={activeTab === 1 ? "active" : ""}
                  >
                    TESTS
                  </li>
                  <li
                    onClick={() => setActiveTab(2)}
                    className={activeTab === 2 ? "active" : ""}
                  >
                    Quizzes
                  </li>
                  <li
                    onClick={() => setActiveTab(3)}
                    className={activeTab === 3 ? "active" : ""}
                  >
                    Study Material
                  </li>
                </ul>
                <section className="tabs-content">
                  <article id="tabs-1">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="image-stack">
                          <img
                            src={`${PUBLIC_URL}/Why-choose-img/Test-img3.png`}
                            className={`stack-img ${activeTab === 1 ? "active" : "inactive"} img-1`}
                            alt=""
                          />

                          <img
                            src={`${PUBLIC_URL}/Why-choose-img/Question-Img3.png`}
                            className={`stack-img ${activeTab === 2 ? "active" : "inactive"} img-2`}
                            alt=""
                          />

                          <img
                            src={`${PUBLIC_URL}/Why-choose-img/Studymaterial-img3.jpeg`}
                            className={`stack-img ${activeTab === 3 ? "active" : "inactive"} img-3`}
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        {activeTab === 1 && (
                          <>
                            <h4>Tests</h4>
                            <p>
                              {" "}
                              Make online tests to get genuine insights into
                              skills and knowledge. Avoid mis-hires and
                              pointless interviews. See the training
                              impact.{" "}
                            </p>
                          </>
                        )}

                        {activeTab === 2 && (
                          <>
                            <h4>Quizzes</h4>
                            <p>
                              {" "}
                              Make quizzes with AI assistance. Evaluate skills
                              and knowledge for deeper understanding through
                              comprehensive analytics.
                            </p>
                          </>
                        )}

                        {activeTab === 3 && (
                          <>
                            <h4>Study Material</h4>
                            <p>
                              Study materials in exam portals provide organized
                              resources aligned with the syllabus, helping
                              candidates prepare effectively. They include
                              topic-wise content, practice questions, and
                              reference materials to enhance learning.
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </article>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section coming-soon" id="section3">
        <div className="container-coming-soon">
          <div className="row continer">
            <h4>
              Unlock new learning opportunities by taking any <em>SUBJECT</em>{" "}
              of your choice, earning your <em>CERTIFICATION</em>
            </h4>
          </div>
          <div className="row">
            <div className="col-lg-6 custom-column1">
              <div className="search-bar-wrapper">
                <div className="search-icon">
                  <FaSearch />
                </div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search for subjects..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
                {searchTerm && (
                  <button className="search-clear-btn" onClick={clearSearch}>
                    <FaTimes />
                  </button>
                )}
              </div>
              <CourseCard
                courses={courses}
                loading={coursesLoading}
                isExpanded={isExpanded}
                toolTip={toolTip}
                isVisible={isVisible}
                sub={sub}
                submitted={submitted}
                setToolTip={setToolTip}
                handleToolTip={handleToolTip}
                handleCoursesChange={handleCoursesChange}
                charLimit={charLimit}
                selectedCountry={selectedCountry}
              />
              
            </div>
            <div className="col-lg-6">
              <div className="right-content">
                {formVisible && (
                  <div>
                    <div className="top-content">
                      <h6>
                        Register your free account and <em>get immediate</em>{" "}
                        access to online courses
                      </h6>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={(values, actions) =>
                        handleSubmit(values, actions)
                      }
                    >
                      {({ touched, errors, resetForm }) => (
                        <Form id="contact" autoComplete="off">
                          <CountryFormSync />
                          <RegistrationStateLoader
                            teleCode={teleCode}
                            setStates={setStates}
                            setStatesLoading={setStatesLoading}
                          />
                          <RegistrationTaxLoader
                            teleCode={teleCode}
                            setTaxRate={setTaxRate}
                          />
                          <div className="row">
                            <div className="col-md-6">
                              <fieldset>
                                <Field
                                  name="firstname"
                                  type="text"
                                  className="form-control"
                                  placeholder="First Name"
                                  required=""
                                  autoComplete="off"
                                  onKeyPress={handleLetterKeyPress}
                                />
                                {touched.firstname && errors.firstname && (
                                  <div className="errorMessage">
                                    {errors.firstname}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            <div className="col-md-6">
                              <fieldset>
                                <Field
                                  name="lastname"
                                  type="text"
                                  className="form-control"
                                  placeholder="Last Name"
                                  required=""
                                  autoComplete="off"
                                  onKeyPress={handleLetterKeyPress}
                                />
                                {touched.lastname && errors.lastname && (
                                  <div className="errorMessage">
                                    {errors.lastname}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            <div className="col-md-12">
                              <fieldset>
                                <Field
                                  name="email"
                                  type="text"
                                  className="form-control"
                                  placeholder="Email address"
                                  required=""
                                  autoComplete="off"
                                />
                                {touched.email && errors.email && (
                                  <div className="errorMessage">
                                    {errors.email}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            <div className="col-lg-5 col-md-4 col-sm-4 col-xs-4">
                              <fieldset>
                                <Field name="telecode">
                                  {({ field, form }) => {
                                    const selectedValue =
                                      form.values.telecode === ""
                                        ? undefined
                                        : form.values.telecode; // <-- key change

                                    return (
                                      <Select
                                        placeholder="Select"
                                        style={{
                                          width: "100%",
                                          height: "40px",
                                          backgroundColor: "transparent",
                                          color: "#FFF",
                                          borderRadius: "0 !important",
                                        }}
                                        showSearch
                                        value={selectedValue}
                                        dropdownStyle={{
                                          backgroundColor:
                                            "rgba(255,255,255,1)",
                                          color: "#000", // !important doesn’t work in JS style
                                        }}
                                        suffixIcon={
                                          <KeyboardArrowDown
                                            style={{ color: "#FFF" }}
                                          />
                                        }
                                        onChange={(val) => {
                                          form.setFieldValue("telecode", val);
                                        }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                          const countryName =
                                            option?.countryname?.toLowerCase() ||
                                            "";
                                          const iso2 =
                                            option?.iso2?.toLowerCase() || "";
                                          const dialCode =
                                            option?.dialcode || "";

                                          return (
                                            countryName.includes(
                                              input.toLowerCase(),
                                            ) ||
                                            iso2.includes(
                                              input.toLowerCase(),
                                            ) ||
                                            dialCode.includes(input)
                                          );
                                        }}
                                      >
                                        {teleCode?.map((item) => (
                                          <Select.Option
                                            key={item.iso2}
                                            value={`${item.iso2}-${item.dialCode}`}
                                            countryname={item.name}
                                            iso2={item.iso2}
                                            dialcode={item.dialCode}
                                          >
                                            <div className="country-option">
                                              <Flag
                                                code={item.iso2}
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                }}
                                              />
                                              <span>
                                                {String(
                                                  item.iso2,
                                                ).toUpperCase()}
                                              </span>
                                              <span>+{item.dialCode}</span>
                                            </div>
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    );
                                  }}
                                </Field>
                                {touched.telecode && errors.telecode && (
                                  <div className="errorMessage">
                                    {errors.telecode}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            <div className="col-lg-7 col-md-8 col-sm-8 col-xs-8">
                              <fieldset>
                                <Field
                                  name="phone"
                                  type="tel"
                                  className="form-control"
                                  placeholder="Phone number"
                                  required=""
                                  autoComplete="off"
                                  onKeyPress={handleNumberKeyPress}
                                />

                                {touched.phone && errors.phone && (
                                  <div className="errorMessage">
                                    {errors.phone}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            <div className="col-md-12">
                              <fieldset className="text-left row">
                                <label
                                  className="radiobutton1"
                                  htmlFor="gender"
                                >
                                  Gender{" "}
                                </label>
                                <Field
                                  type="radio"
                                  className="radio"
                                  name="gender"
                                  value="M"
                                />{" "}
                                <span htmlFor="male" className="radiobutton">
                                  Male
                                </span>
                                <Field
                                  type="radio"
                                  className="radio "
                                  name="gender"
                                  value="F"
                                />{" "}
                                <span htmlFor="female" className="radiobutton">
                                  Female
                                </span>
                                {touched.gender && errors.gender && (
                                  <div
                                    className="errorMessage"
                                    style={{
                                      marginLeft: "15px",
                                      marginTop: "0px",
                                      color: "red",
                                    }}
                                  >
                                    {errors.gender}
                                  </div>
                                )}
                              </fieldset>
                            </div>
                            {/* TIMEZONE */}
                            <div className="col-md-12">
                              <fieldset>
                                  <Field name="timezone">
                                    {({ field, form }) => {
                                      const selectedValue =
                                        form.values.timezone === ""
                                          ? undefined
                                          : form.values.timezone;

                                      return (
                                        <Select
                                          className="reg-select"
                                          placeholder="Select Time Zone"
                                          style={{
                                            width: "100%",
                                            color: "#FFF",
                                          }}
                                          showSearch
                                          variant="borderless"
                                          value={selectedValue}
                                          suffixIcon={
                                            <KeyboardArrowDown
                                              style={{ color: "#FFF" }}
                                            />
                                          }
                                          onChange={(val) => {
                                            form.setFieldValue("timezone", val);
                                          }}
                                        >
                                          {timeZone?.map((item, index) => (
                                            <Select.Option
                                              key={index}
                                              value={item}
                                            >
                                              {item}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      );
                                    }}
                                  </Field>

                                  {touched.timezone && errors.timezone && (
                                    <div className="errorMessage">
                                      {errors.timezone}
                                    </div>
                                  )}
                                </fieldset>
                              </div>

                            {/* COUNTRY */}
                            <div className="col-md-12">
                              <fieldset>
                                  <Field name="country">
                                    {({ field, form }) => {
                                      const selectedValue =
                                        form.values.country === ""
                                          ? undefined
                                          : form.values.country;

                                      return (
                                        <Select
                                          className="reg-select"
                                          placeholder="Select Country"
                                          style={{
                                            width: "100%",
                                            color: "#FFF",
                                          }}
                                          showSearch
                                          variant="borderless"
                                          value={selectedValue}
                                          suffixIcon={
                                            <KeyboardArrowDown
                                              style={{ color: "#FFF" }}
                                            />
                                          }
                                          onChange={(val) => {
                                            form.setFieldValue("country", val);
                                            form.setFieldValue("state", "");
                                            setSelectedCountry(val);
                                            const matched = teleCode.find(
                                              (item) =>
                                                item.name?.toLowerCase() ===
                                                String(val).toLowerCase(),
                                            );
                                            if (
                                              matched?.iso2 &&
                                              matched?.dialCode != null
                                            ) {
                                              form.setFieldValue(
                                                "telecode",
                                                `${matched.iso2}-${matched.dialCode}`,
                                              );
                                            }
                                          }}
                                        >
                                          {teleCode?.map((item) => (
                                            <Select.Option
                                              key={item.iso2}
                                              value={item.name}
                                            >
                                              <div className="country-option">
                                                <Flag
                                                  code={item.iso2}
                                                  style={{
                                                    height: "18px",
                                                    width: "18px",
                                                  }}
                                                />
                                                <span>{item.name}</span>
                                              </div>
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      );
                                    }}
                                  </Field>

                                  {touched.country && errors.country && (
                                    <div className="errorMessage">
                                      {errors.country}
                                    </div>
                                  )}
                                </fieldset>
                              </div>

                            {/* STATE */}
                            <div className="col-md-12">
                              <fieldset>
                                  <Field name="state">
                                    {({ field, form }) => {
                                      const selectedValue =
                                        form.values.state === ""
                                          ? undefined
                                          : form.values.state;
                                      const hasCountry = Boolean(
                                        form.values.country,
                                      );
                                      const showSelect =
                                        hasCountry &&
                                        (statesLoading || states.length > 0);

                                      if (!showSelect) {
                                        return (
                                          <input
                                            {...field}
                                            type="text"
                                            className="form-control"
                                            placeholder="State"
                                            autoComplete="off"
                                            disabled={!hasCountry}
                                          />
                                        );
                                      }

                                      return (
                                        <Select
                                          className="reg-select"
                                          placeholder="Select State"
                                          style={{
                                            width: "100%",
                                            color: "#FFF",
                                          }}
                                          showSearch
                                          variant="borderless"
                                          value={selectedValue}
                                          loading={statesLoading}
                                          disabled={!hasCountry}
                                          suffixIcon={
                                            <KeyboardArrowDown
                                              style={{ color: "#FFF" }}
                                            />
                                          }
                                          onChange={(val) => {
                                            form.setFieldValue("state", val);
                                          }}
                                          options={states.map((item) => ({
                                            value: item.name,
                                            label: item.name,
                                          }))}
                                          optionFilterProp="label"
                                          listHeight={280}
                                          virtual={false}
                                          popupClassName="reg-select-dropdown"
                                          getPopupContainer={getPopupContainer}
                                          notFoundContent={
                                            statesLoading
                                              ? "Loading states..."
                                              : "No states found"
                                          }
                                        />
                                      );
                                    }}
                                  </Field>

                                  {touched.state && errors.state && (
                                    <div className="errorMessage">
                                      {errors.state}
                                    </div>
                                  )}
                                </fieldset>
                            </div>
                            <div className="col-md-12">
                              <fieldset>
                                <button
                                  type="submit"
                                  id="form-submit"
                                  className="button"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? (
                                    <span className="loading-spinner">
                                      <i className="fa fa-spinner fa-spin"></i>{" "}
                                      Processing...
                                    </span>
                                  ) : (
                                    "Get it now"
                                  )}
                                </button>
                              </fieldset>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div>
                      {errorMsgCourse && (
                        <div className="errorMessageCourses">
                          Select one of the subjects provided
                        </div>
                      )}

                      {showErrorMsgUser && errorMsgUser && (
                        <div className="errorMessageCourses">
                          {errorMsgUser}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {userSaved && (
                  <div className="tailspin">
                    <div className="tailspin-sub">
                      <TailSpin />
                    </div>
                  </div>
                )}
                {showPaymentPendingModal && (
                  <div className="modal-overlay">
                    <div className="modal-card">
                      <div className="modal-icon">⚠️</div>

                      <h3 className="modal-title">Payment Pending</h3>

                      <p className="modal-subtext">
                        Your registration is successful, but payment is still
                        incomplete.
                      </p>

                      <p className="modal-highlight">
                        🎁 Get <strong>7 days free trial access</strong> after
                        payment
                      </p>

                      <div className="modal-actions">
                        <button
                          className="btn-primary"
                          onClick={async () => {
                            setcuserid(existingCandidateId);
                            setShowPaymentPendingModal(false);

                            if (await fetchIsTestMode()) {
                              await completeTestModePayment(existingCandidateId);
                              return;
                            }

                            const country = selectedCountry
                              ?.toLowerCase()
                              .trim();

                            console.log("MODAL COUNTRY :", country);

                            // ✅ INDIA -> Razorpay Checkout (test keys)
                            if (country?.includes("india")) {
                              setFormVisible(false);
                              setRedeemVisible(true);
                              setcuserid(existingCandidateId);
                              await openRazorpay(existingCandidateId);
                            } else {
                              // ✅ OTHER COUNTRY
                              setFormVisible(false);
                              setPayThroughVisible(true);
                            }
                          }}
                        >
                          Continue to Pay
                        </button>

                        <button
                          className="btn-secondary"
                          onClick={() => setShowPaymentPendingModal(false)}
                        >
                          Maybe Later
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {redeemVisible && (
                  <div className="payment-content">
                    <div className="payment-signup">
                      <div className="payment-top-content">
                        <h4>
                          Signing up includes{" "}
                          <span style={{ color: "#f5a425" }}>1 FREE week</span>{" "}
                          of Premeium
                        </h4>
                      </div>
                      <ul>
                        <li>
                          <MdVerified
                            style={{
                              marginRight: "5px",
                              marginBottom: "2px",
                            }}
                          />
                          Practice Test
                        </li>
                        <li>
                          <MdVerified
                            style={{
                              marginRight: "5px",
                              marginBottom: "2px",
                              // color: "#0066ff",
                            }}
                          />
                          Study Material
                        </li>
                      </ul>
                      <div>
                        <img
                          style={{ height: "100px" }}
                          src={`${PUBLIC_URL}/assets/images/logo.png`}
                          alt="Nextestify"
                        />{" "}
                      </div>
                      <p>
                        1 week free, then{" "}
                        <span
                          style={{
                            color: "#f5a425",
                            fontWeight: 700,
                            fontSize: "15px",
                          }}
                        >

                          {selectedCountry?.toLowerCase()?.includes("india")
                            ? `₹ ${Number(totalAmt).toFixed(2)}`
                            : `$ ${Number(totalAmt).toFixed(2)}`}
                        </span>{" "}
                        - Cancel anytime
                      </p>
                      <div className="main-button">
                        <div className="scroll-to-section">
                          <a href="#section3" onClick={handlePayThrough}>
                            {isRedeeming ? (
                              <span className="loading-spinner">
                                <i className="fa fa-spinner fa-spin"></i>{" "}
                                Processing...
                              </span>
                            ) : (
                              "Redeem 1 Week FREE"
                            )}
                          </a>
                        </div>
                      </div>
                      <button className="pointer" onClick={handleNoTQ}>
                        No, Thank you
                      </button>
                      {showErrorMsgUser && errorMsgUser && (
                        <div className="errorMessageCourses" style={{ marginTop: "12px" }}>
                          {errorMsgUser}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {payThroughVisible && (
                  <PaymentForms
                    totalAmt={totalAmt}
                    discountAmt={discountAmt}
                    cuserid={cuserid}
                    sub={sub}
                    finalrender={finalrender}
                    setUserSaved={setUserSaved}
                  />
                )}
              
                {paymentSuccess && (
                  <div className="flex items-center justify-center h-[350px]">
                    <div className="bg-[#0f172a] border border-green-500/30 rounded-xl shadow-xl p-8 text-center max-w-md w-full">
                      {/* ICON */}
                      <div className="flex justify-center mb-4">
                        <div className="bg-green-500/20 p-4 rounded-full">
                          <svg
                            className="w-10 h-10 text-green-400"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                      </div>

                      <h2 className="text-2xl font-bold text-green-400 mb-2">
                        {successHeading}
                      </h2>

                      <p className="text-gray-300 text-sm mb-6">
                        {selectedCountry?.toLowerCase()?.includes("india")
                          ? "Your Razorpay payment was successful and your 7-day free trial has started."
                          : "Your course has been activated successfully. You now have access to all selected subjects."}
                      </p>

                      <button
                        onClick={() => {
                          window.location.href = process.env.REACT_APP_OEPPORTAL;
                        }}
                        className="bg-[#F4A62A] hover:bg-[#f4a62ad9] text-white px-6 py-2 rounded-md font-semibold transition"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section video" id="section5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-center">
              <div className="left-content">
                <span>our presentation is for you</span>
                <h4>
                  Watch the video to learn more <em>about NexTestify</em>
                </h4>
                <p>
                  Watch the video to learn more about&nbsp;
                  <a href="/Nextestify">NexTestify</a>, the ultimate platform
                  for creating and taking online tests. In this video, we'll
                  guide you through the process of setting up your tests,
                  managing your questions, and tracking progress. Whether you're
                  an educator or a learner, NexTestify makes online testing
                  simple, efficient, and engaging.
                </p>
                Watch now to get started and maximize your testing experience
                for details.
                <div className="main-button">
                  <a
                    href={`${PUBLIC_URL}/assets/images/nexTestifyVideo.mp4`}
                    className="play"
                  >
                    VIEW VIDEO
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <article className="video-item">
                <div className="video-caption">
                  <h4>Nextestify Guide</h4>
                </div>
                <figure>
                  <a href={nextestify_Video} className="play">
                    <img
                      src={`${PUBLIC_URL}/assets/images/main-thumb.png`}
                      alt=""
                    />
                  </a>
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="section contact" id="section6">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-heading">
                <h2>Let’s Keep In Touch</h2>
              </div>
            </div>
            <div className="col-md-6">
              <EmailForm />
            </div>
            <div className="col-md-6">
              <MapView />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
